// Prefix for parameters specific to interactions
export const INTERACTIONS_TABLE_PREFIX = "InteractionsTable";
